var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatagenerator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12750_36373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 45,
    fill: "url(#paint0_radial_12750_36373)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 45,
    fill: "url(#paint1_linear_12750_36373)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 52.3333C50.5278 52.3333 46.9097 51.6528 44.1458 50.2917C41.3819 48.9306 40 47.3889 40 45.6667C40 43.9167 41.3819 42.3681 44.1458 41.0208C46.9097 39.6736 50.5278 39 55 39C59.4722 39 63.0903 39.6736 65.8542 41.0208C68.6181 42.3681 70 43.9167 70 45.6667C70 47.3889 68.6181 48.9306 65.8542 50.2917C63.0903 51.6528 59.4722 52.3333 55 52.3333ZM55 60.6667C50.9444 60.6667 47.4306 60.0556 44.4583 58.8333C41.4861 57.6111 40 56.1389 40 54.4167V50.25C40 51.3333 40.5208 52.2708 41.5625 53.0625C42.6042 53.8542 43.8958 54.5069 45.4375 55.0208C46.9792 55.5347 48.6181 55.9097 50.3542 56.1458C52.0903 56.3819 53.6389 56.5 55 56.5C56.3889 56.5 57.9444 56.3819 59.6667 56.1458C61.3889 55.9097 63.0208 55.5417 64.5625 55.0417C66.1042 54.5417 67.3958 53.8958 68.4375 53.1042C69.4792 52.3125 70 51.3611 70 50.25V54.4167C70 56.1389 68.5139 57.6111 65.5417 58.8333C62.5694 60.0556 59.0556 60.6667 55 60.6667ZM55 69C50.9444 69 47.4306 68.3889 44.4583 67.1667C41.4861 65.9444 40 64.4722 40 62.75V58.5833C40 59.6667 40.5208 60.6042 41.5625 61.3958C42.6042 62.1875 43.8958 62.8403 45.4375 63.3542C46.9792 63.8681 48.6181 64.2431 50.3542 64.4792C52.0903 64.7153 53.6389 64.8333 55 64.8333C56.3889 64.8333 57.9444 64.7153 59.6667 64.4792C61.3889 64.2431 63.0208 63.875 64.5625 63.375C66.1042 62.875 67.3958 62.2292 68.4375 61.4375C69.4792 60.6458 70 59.6944 70 58.5833V62.75C70 64.4722 68.5139 65.9444 65.5417 67.1667C62.5694 68.3889 59.0556 69 55 69Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8312 11.6603C53.8312 10.7433 53.0875 9.99667 52.1713 10.0319C44.0839 10.3424 36.2271 12.9169 29.4799 17.4854C22.2719 22.3658 16.6539 29.3026 13.3364 37.4185C10.019 45.5344 9.15097 54.4649 10.8422 63.0806C12.4254 71.1458 16.1845 78.5961 21.6867 84.6107C22.3073 85.289 23.3659 85.287 24.0117 84.6326V84.6326C24.6455 83.9904 24.6428 82.9602 24.0351 82.2932C18.9741 76.7388 15.5156 69.8682 14.0561 62.4328C12.4913 54.4612 13.2944 46.1983 16.3639 38.6892C19.4333 31.18 24.6313 24.7619 31.3004 20.2463C37.5087 16.0428 44.7322 13.6637 52.1713 13.355C53.0874 13.3169 53.8312 12.5772 53.8312 11.6603V11.6603Z",
    fill: "url(#paint2_linear_12750_36373)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12750_36373",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0823529 0 0 0 0 0.196078 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12750_36373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12750_36373",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12750_36373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55 55) rotate(89.2559) scale(45.0038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762092,
    stopColor: "#0D116B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12750_36373",
    x1: 28.7013,
    y1: 19.9351,
    x2: 52.6623,
    y2: 54.4156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E61D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E62D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12750_36373",
    x1: 53.8312,
    y1: 10,
    x2: 25.7877,
    y2: 86.8736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatagenerator);
export default __webpack_public_path__ + "static/media/datagenerator.c9852b181e6d1d8b140affd66004d76f.svg";
export { ForwardRef as ReactComponent };